var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('span',[_vm._v("Copyright © "+_vm._s(_vm.curYear)+", ProfetAI Inc. rights reserved.")])])}
var staticRenderFns = []

export { render, staticRenderFns }